// Web Crypto is available on every target (browsers, Workers, Bun, Node 20+, React Native via
// polyfill) but pure packages compile without the DOM lib, so declare the one member we use.
declare const crypto: { randomUUID(): string };

/** Client-side UUID v4 so entities can be created offline on every platform. */
export function newId(): string {
  return crypto.randomUUID();
}
